import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
    getRevenues,
    addRevenue,
    updateRevenue,
    deleteRevenue
} from '../../../../api/apiServices';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'
import { format, sub } from "date-fns";
import UserRoles from '../../../../hooks/userRoles';
import useAuth from "../../../../hooks/useAuth";
import jwt_decode from "jwt-decode";

const Revenue = () => {
    const { auth } = useAuth();
    const decoded = auth?.accessToken
        ? jwt_decode(auth.accessToken)
        : undefined

    const role = decoded?.UserInfo?.role || ""

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [search, setSearch] = useState(false);

    const [revenue_year, setRevenueYear] = useState("");
    const [type, setType] = useState("");
    const [name, setName] = useState("");
    const [amount, setAmount] = useState("");
    const [transaction_date, setTransactionDate] = useState("");
    const [payment_mode, setPaymentMode] = useState("");

    const year = (new Date()).getFullYear();
    const years = Array.from(new Array(20), (val, index) => index + year)

    const queryClient = useQueryClient();

    const {
        isLoading,
        isError,
        error,
        data: revenues
    } = useQuery('revenues', getRevenues, {
        select: data => data.sort((a, b) => b.id - a.id)
    });

    const addRevenueMutation = useMutation(addRevenue, {
        onSuccess: () => {
            // Invalidate cached data
            queryClient.invalidateQueries("revenues")
        }
    })
    const deleteRevenueMutation = useMutation(deleteRevenue, {
        onSuccess: () => {
            // Invalidate cached data
            queryClient.invalidateQueries("revenues")
        }
    })
    const handleConfirm = (id) => {
        if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <div className='confirm-delete'>
                                <h3>Confirm Delete</h3>
                                <p>Do you want to delete the revenue ?</p>
                                <br />
                                <div className='confirm-buttons'>
                                    <button
                                        style={{ width: "100px" }}
                                        className="btn btn-danger"
                                        onClick={onClose}
                                    >
                                        No
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button
                                        style={{ width: "100px" }}
                                        className="btn btn-success"
                                        onClick={() => { deleteRevenueMutation.mutate(id); onClose(); }}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        } else {
            toast.error("You are not authorized to perform this function. Contact the System Administrator", {
                duration: 3000,
                className: "toast-message"
            });
            return false
        }
    }

    const handleCancel = () => {
        setSearch(false)
    }

    const handleEdit = (id) => {
        if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
            navigate(`/edit_revenue/${id}`)
        } else {
            toast.error("You are not authorized to perform this function. Contact the System Administrator", {
                duration: 3000,
                className: "toast-message"
            });
            return false
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const minDate = sub(new Date(), {
            months: 6
        });

        const dateFormat = "yyyy-MM-dd";
        const transDate = transaction_date;
        const tDate = new Date(transDate);
        const today = new Date();
        const distance = today.getTime() - tDate.getTime();
        const daysOld = Math.floor(distance / (1000 * 60 * 60 * 24));
        console.log(daysOld)
        const transAge = Number((daysOld / 30).toFixed(0));
        console.log(transAge)

        if (transAge > 6) {
            toast.error(`The acceptable transaction date is ${format(
                minDate,
                dateFormat
            )} and above`);
            setTransactionDate(transDate)
            return false;
        } else {
            setTransactionDate(transDate)
            addRevenueMutation.mutate({
                year: year,
                transaction_date: transaction_date,
                name: name,
                type: type,
                amount: amount,
                expense_code: "REV1001",
                completed: false,
            });
            // setNewRevenue("")
            setRevenueYear("");
            setTransactionDate("");
            setName("");
            setType("");
            setAmount("");
            setPaymentMode("")
        }
    }
    const newItemSection = role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin ?
        (
        <>
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="panel-title">
                                NEW REVENUE ITEMS
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group row">
                            <label htmlFor="revenue_year" className="col-sm-2">Year</label>
                            <div className="col-sm-4">
                                <select
                                    type="text"
                                    id="revenue_year"
                                    placeholder='revenue_year'
                                    autoComplete="off"
                                    style={{ textTransform: "capitalize" }}
                                    onChange={(e) => setRevenueYear(e.target.value)}
                                    required
                                    value={revenue_year}
                                    name="year"
                                    className="form-control"
                                >
                                    <option>Select Year</option>
                                    {years.map((year, index) => <option value={year} key={`year${index}`}>{year}</option>
                                    )}
                                </select>
                            </div>

                            <label htmlFor="transaction_date" className="col-sm-2">Transaction Date <span>&nbsp;&nbsp;*</span></label>
                            <div className="col-sm-4">
                                <input
                                    type="date"
                                    id="transaction_date"
                                    autoComplete="off"
                                    onChange={(e) => setTransactionDate(e.target.value)}
                                    required
                                    value={transaction_date}
                                    name="transaction_date"
                                    className="form-control" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="type" className="col-sm-2">Revenue Type <span>&nbsp;&nbsp;*</span></label>
                            <div className="col-sm-4">
                                <select
                                    type="text"
                                    id="type"
                                    placeholder='Revenue Type'
                                    autoComplete="off"
                                    style={{ textTransform: "capitalize" }}
                                    onChange={(e) => setType(e.target.value)}
                                    required
                                    value={type}
                                    name="type"
                                    className="form-control"
                                >
                                    <option>Select Revenue Type</option>
                                    <option value="Office Expenses">Office Expenses</option>
                                    <option value="Travelling Expenses">Travelling Expenses</option>
                                    <option value="Hotel Expenses">Hotel Expenses</option>
                                    <option value="Inconvenient Allowance">Inconvenient Allowance</option>
                                    <option value="Miscellaneous Expenses">Miscellaneous Expenses</option>
                                </select>
                            </div>

                            <label htmlFor="name" className="col-sm-2">Revenue Name <span>&nbsp;&nbsp;*</span></label>
                            <div className="col-sm-4">
                                <input
                                    type="text"
                                    id="name"
                                    autoFocus
                                    autoComplete="off"
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                    required
                                    name="name"
                                    className="form-control" />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="amount" className="col-sm-2">Amount <span>&nbsp;&nbsp;*</span></label>
                            <div className="col-sm-4">
                                <input
                                    type="number"
                                    id="amount"
                                    autoFocus
                                    autoComplete="off"
                                    onChange={(e) => setAmount(e.target.value)}
                                    value={amount}
                                    required
                                    name="amount"
                                    className="form-control" />
                            </div>
                            <label htmlFor="payment_mode" className="col-sm-2">Payment Mode <span>&nbsp;&nbsp;*</span></label>
                            <div className="col-sm-4">
                                <select
                                    type="text"
                                    id="payment_mode"
                                    placeholder='payment_mode'
                                    autoComplete="off"
                                    style={{ textTransform: "capitalize" }}
                                    onChange={(e) => setPaymentMode(e.target.value)}
                                    required
                                    value={payment_mode}
                                    name="payment_mode"
                                    className="form-control"
                                >
                                    <option>Select Payment Mode</option>
                                    <option value="C">CASH</option>
                                    <option value="Q">CHEQUE</option>
                                    <option value="M">MOMO</option>
                                    <option value="B">BANK CARD</option>                                    
                                </select>
                            </div>
                        </div>
                        <div className="panel-footer">
                            <button type="submit" className="btn btn-danger" onClick={handleCancel}>
                                <i className='fas fa-cancel'></i> Cancel
                            </button>&nbsp;&nbsp;
                            <button type="submit" className="btn btn-success">
                                <i className='fas fa-upload'></i> Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    ):(null)

    let content
    if (isLoading) {
        content = <p>Loading...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            <><div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="panel-title">
                                REVENUE RECEIVED ITEMS
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className='table-responsive lg'>
                    <table className='table table-borderless table-striped'>
                            <thead>
                                <tr>
                                    <th scope="col" style={{ textAlign: 'center' }}>#</th>
                                    <th scope="col">DATE</th>
                                    <th scope="col">NAME</th>
                                    <th scope="col">TYPE</th>
                                    <th scope="col" style={{ textAlign: "right" }}>AMOUNT</th>
                                    <th scope="col" style={{ textAlign: "center" }}>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {revenues.map((expense, index) => <tr key={expense.id}>
                                    {/* <td style={{ textAlign: 'center' }}>{postPerPage * (currentPage - 1) + index + 1}</td> */}
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{expense.transaction_date}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{expense.name}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{expense.type}</td>
                                    <td style={{ textAlign: "right" }}>{expense.amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    <td style={{ whiteSpace: 'nowrap', textAlign: "center" }}>
                                        <div style={{ display: 'inline-block' }}>
                                            <Link to={`/view_revenues/${expense.id}`} className="small"><i className='fa fa-eye'></i> view</Link>
                                        </div>&nbsp; &nbsp;
         
                                        <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                            <Link className="small" onClick={(e) => handleEdit(expense.id)}><i className='fa fa-trash'></i> edit</Link>
                                   {/* <Link to={`/edit_revenues/${expense.id}`} className="small mr-3">
                                                <i className='fa fa-edit'></i> update
                                            </Link> */}
                                        </div>
                                        &nbsp;&nbsp;
                                        <div style={{ display: 'inline-block' }}>
                                            <Link className="small" onClick={(e) => handleConfirm(expense.id)}><i className='fa fa-trash'></i> delete</Link>
                                        </div>
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="panel-body">
                </div>
            </div>
            </>
    }

    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1>Revenue Management</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {newItemSection}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                        </div>
                    </div>
                    <div className="box-footer">
                    </div>
                </div>
            </section >
        </>
    )
}

export default Revenue